import { Environment } from '@env/environment.model';

export const environment: Environment = {
    production: true,
    cmsUrl: 'https://cms.k8s.xpertyme.com',
    tenant: 'tyme-group',
};
